import { render } from "./OrderSuccessView.vue?vue&type=template&id=3beec38a&ts=true"
import script from "./OrderSuccessView.vue?vue&type=script&lang=ts"
export * from "./OrderSuccessView.vue?vue&type=script&lang=ts"

import "./OrderSuccessView.vue?vue&type=style&index=0&id=3beec38a&lang=postcss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__